<template>
<div>

    <div class="vx-card">
        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>Fiche Nouveau Article PHARMA</h4>
            </div>
        </div>

        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->

                <div class="vx-row w-full">
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Code PCT</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.code" class="w-full" required icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Code à bare</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.barcode" class="w-full" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>
                        <!-- Save & Reset Button -->
                    </div>

                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Désignation</label>

                                <div class="mt-2">
                                    <vs-input class="w-full" v-model="selectedProd.designation" icon-pack="feather" required icon="icon-info" />
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2 ">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Fournisseur</label>

                                <div class="mt-2">
                                    <vs-input class="w-full" v-model="selectedProd.fournisseur" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex  vx-col md:w-full pt-5">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Laboratoire</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.laboratoire" class="w-full" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Fabricant</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.fabricant" class="w-full" icon-pack="feather" icon="icon-info" />

                                    <span class="text-danger text-sm" v-show="errors.has('tva')">{{ errors.first('tva') }}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="flex  vx-col md:w-full pt-5">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Bureau de Promotion</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.bureauPromotion" class="w-full" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-5">
                                <label class="block text-gray-700 text-sm font-bold">Prix UHT</label>

                                <div class="mt-2">
                                    <vs-input class="w-full" v-model="selectedProd.prixUHT" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-5">
                                <label class="block text-gray-700 text-sm font-bold">TVA</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.tva" class="w-full" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Prix UHT Grossiste</label>

                                <div class="mt-2">
                                    <vs-input class="w-full" v-model="selectedProd.prixUnitHTGrossiste" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">DCI_1</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.DCI_1" class="w-full" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>

                        <!-- Save & Reset Button -->
                    </div>
                    <div class="flex mb-4 vx-col md:w-full"  v-if="updateProd==null">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/4 sm:w-1/2 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Photo d'article</label>

                                <div class="mt-1 vx-row   ">
                                    <label>
                                        <vs-upload limit="1" ref="upImageref" @change="preview1()" />
                                    </label>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="vx-card mt-5">
        <div class="vx-card__header">
            <div class="vx-card__title">

            </div>
        </div>

        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->

                <div class="vx-row w-full h-full">

                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">DCI_II</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.DCI_II" class="w-full" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Classe thérapeutique</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.classeTh" class="w-full" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Colisage</label>

                                <div class="mt-2">
                                    <vs-input class="w-full" v-model="selectedProd.colisage" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Chaine de froid</label>

                                <div class="mt-1">
                                    <div class="mt-2">
                                        <vs-checkbox v-model="selectedProd.chaineFroid">Chaine de froid</vs-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-5">
                                <label class="block text-gray-700 text-sm font-bold">Type de Produit</label>

                                <div class="mt-2">
                                    <v-select readonly class="w-full" v-model="selectedProd.typePharma" :options="optionsTypePro" />
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary h-12 px-2 ">
                            <div class="w-full mt-10">
                                <label class="block text-gray-700 text-sm font-bold">Générique/Princeps</label>

                                <div class="vx-row mt-2 mr-5">
                                    <div class=" ">
                                        <vs-checkbox v-model="selectedProd.génerique">Générique</vs-checkbox>
                                    </div>
                                    <div class=" ">
                                        <vs-checkbox v-model="selectedProd.princeps">Princeps</vs-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex mb-4 vx-col md:w-full mt-3">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-10">
                                <label class="block text-gray-700 text-sm font-bold">Nom Complet (Emetteur)</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.nomEmetteur" class="w-full" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-10">
                                <label class="block text-gray-700 text-sm font-bold">Téléphone (Emetteur)</label>

                                <div class="mt-2">
                                    <vs-input v-model="selectedProd.telEmetteur" class="w-full" icon-pack="feather" icon="icon-info" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex mb-4 vx-col md:w-full mt-3">
                        <div class="w-full mt-1">
                            <div class="mt-2 float-right">
                                <vs-button :disabled="selectedProd.errors" @click="saveNouvelleCreationArticle()">Enregistrer</vs-button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import indexArt from "@/http/requests/article/index.js";
import vSelect from "vue-select";
export default {
    props: {
        updateProd: {
            type: Object,
            default: null
        },
    },
    created() {
        if (this.updateProd != null)
            this.selectedProd = this.updateProd;
    },
    data() {
        return {
            colorx: this.$store.state.themePrimaryColor,

            selectedProd: {
                type: "PHARMA",
                code: "",
                designation: "",
                gamme: "",
                barcode: "",
                DCI_1: "",
                DCI_2: "",
                fournisseur: "",
                prixUnitHTGrossiste: '',
                prixVenteConseille: '',
                coutDRTConsommation: '',
                TVA: "",
                remise: "",
                colisage: "",
                nomEmetteur: "",
                fodec: "",
                typePharma: "",
                image: {}
            },
            optionsTva: [{
                    id: "19",
                    label: "19 %"
                },
                {
                    id: "19/achat",
                    label: "19/achat"
                },
                {
                    id: "7/achat",
                    label: "7/achat"
                }
            ],
            optionsTypePro: [{
                    id: "A",
                    label: "Type A"
                },
                {
                    id: "B",
                    label: "Type B"
                },
                {
                    id: "C",
                    label: "Type C"
                }
            ]
        }
    },
    methods: {
        preview1() {

            var files1 = this.$refs.upImageref.filesx;
            if (files1.length === 0) {
                return;
            }
            let filename = files1[0].name;
            this.selectedProd.image.filename = filename;
            this.selectedProd.image.fileURL1 = files1[0]

        },
        saveNouvelleCreationArticle() {
            this.selectedProd.typePharma = this.selectedProd.typePharma.label
            console.log(this.selectedProd)
            indexArt
                .saveNouvelleCreationArticle(this.selectedProd)
                .then(response => {
                    console.log(response);
                    this.$vs.dialog({
                        type: "confirm",
                        color: "primary",
                        title: `Nouvelle Création`,
                        text: response.data
                    });
                    this.selectedProd = {}
                })
                .catch(error => {
                    this.$vs.dialog({
                        type: "confirm",
                        color: "warning",
                        title: `Nouvelle Création`,
                        text: error.response.data
                    });
                });
        },
    },
    components: {
        vSelect,

    },
    computed: {

    }
}
</script>

<style>

</style>
